<template>
  <el-dialog title="Configure AI Prompt for Link" :width="dialogWidth" :visible.sync="visible" :close-on-click-modal="false">
    <div class="content_div">
      <div class="form" v-loading="form_loading">
        <el-alert
          :closable="false"
          description="Configure the AI review generation rules specifically for this survey link. Leave fields blank to use the default rules set at the locaion level(shown as placeholders).Custom keywords override location keywords for preivew."
          type="info">
        </el-alert>
        <div class="div" style="">
          Name
          <el-input class="margin-top-switch" placeholder="John Doe" v-model="account_obj.employee_name"/>
        </div>

        <div class="div">
          Position
          <el-input class="margin-top-switch" placeholder="Sales Assistant" v-model="account_obj.employee_position"/>
        </div>

        <div class="div">
          Custom Keywords for this Link
          <el-alert
            :closable="false"
            style="font-weight: normal;"
            description="Enter comma-separated keywords. If empty, location keywords will be used for selection.These keywords will be saved with the link’s prompt settings."
            type="info">
          </el-alert>
          <el-input
            style="margin-top:10px;"
            type="textarea"
            :rows="4"
            placeholder="Experience, Comprehensive, Comfortable"
            @blur="get_workword_number"
            v-model="keyword">
          </el-input>
          <div style="font-size: 12px;font-weight: normal;color: #909399;display: flex;align-items: center;justify-content: end;margin-top: 5px;">
            {{keyword_array.length}} keywords entered
          </div>
        </div>

        <div class="div">
          Common Rules
          <el-alert
            :closable="false"
            style="font-weight: normal;"
            description="Rules applied to all generated reviews."
            type="info">
          </el-alert>
          <el-input
            type="textarea"
            style="margin-top:10px;"
            placeholder="Mention Jone Doe. He’s a Male office manager, He’s a stable at the office and is known for his providing exceptional patience experience, always find a way to help patients get the treatment they need even when financing is a challenge. Known for his laughter, friendly, very open."
            :rows="4"
            v-model="account_obj.common_rules"
            maxlength="2048"
            show-word-limit></el-input>
        </div>

        <div class="div">
          Rules for the 1st variation
          <el-alert
            :closable="false"
            style="font-weight: normal;"
            description="Specific rules for the first generated review."
            type="info">
          </el-alert>
          <el-input
            type="textarea"
            style="margin-top:10px;"
            placeholder="Make it similar to yelp reviews, keep it concise, and easy to read. Use random incomplete sentences. Use personal stories when possible. Write in 4th or 5th grade level. Make it 2 to 4 sentences long. Write with incomplete senteces."
            :rows="4"
            v-model="account_obj.rules_for_first_variation"
            maxlength="2048"
            show-word-limit></el-input>
        </div>

        <div class="div">
          Rules for 2nd Review
          <el-alert
            :closable="false"
            style="font-weight: normal;"
            description="Specific rules for the second generated review."
            type="info">
          </el-alert>
          <el-input
            type="textarea"
            style="margin-top:10px;"
            placeholder="Make it similar to yelp reviews, make it 3 to 5 senttences, and easy to read. Use random incomplete sentences. Use personal stories when possible. Write with incomplete sentences."
            :rows="4"
            v-model="account_obj.rules_for_second_variation"
            maxlength="2048"
            show-word-limit></el-input>
        </div>

      </div>
    </div>
    <div class="dialog-footer" style="display: flex;justify-content: flex-end;margin-top: 15px;">
      <el-button type="primary" size="small" @click="save_send" style="background-color: #5856D6;border-color:#5856D6;">Save Settings</el-button>
    </div>
  </el-dialog>

</template>

<script>
import Vue from 'vue';
import { getActionApi, postActionApi } from '@/network/manageApi';
export default {
  name: 'AddStaffs',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      visible: false,
      account_obj: {},
      form_loading: false,
      keyword_array:[],
      keyword: ''
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    get_workword_number() {
      let use_keyword = this.keyword.replaceAll(/^,?\s*|\s*,?$/g, '');
      if(use_keyword) {
        let array = use_keyword.split(",")
        let target_array = []
        for(let item of array) {
          let target = item.replaceAll(/^,?\s*|\s*,?$/g, '')
          if(target != "") {
            target_array.push(target)
          }
        }
        this.keyword_array = target_array
        this.keyword = target_array.join(",")
      } else {
        this.keyword_array = []
      }
    },
    init() {
      this.visible = true
      this.account_obj = {}
      this.keyword = ''
    },
    save_send() {
      if(!this.account_obj.employee_name) {
        this.$message({
          message: 'Please enter name.',
          type: 'warning'
        });
        return;
      }
      if(!this.account_obj.employee_position) {
        this.$message({
          message: 'Please enter position.',
          type: 'warning'
        });
        return;
      }
      if(this.keyword_array.length == 0) {
        this.$message({
          message: 'Please enter custom keywords.',
          type: 'warning'
        });
        return;
      }
      if(!this.account_obj.common_rules) {
        this.$message({
          message: 'Please enter common rules.',
          type: 'warning'
        });
        return;
      }
      if(!this.account_obj.rules_for_first_variation) {
        this.$message({
          message: 'Please enter 1st variation.',
          type: 'warning'
        });
        return;
      }
      if(!this.account_obj.rules_for_second_variation) {
        this.$message({
          message: 'Please enter 2nd variation.',
          type: 'warning'
        });
        return;
      }
      this.account_obj.employee_keywords = this.keyword_array
      this.form_loading = true
      postActionApi("/review/business-promoter/staff", this.account_obj).then((res) => {
        if(res.code == 201 || res.code == 200) {
          this.$emit('ok')
          this.$message.success({message: "Save Success"});
          this.visible = false
        }
      }).catch((err) => {
        this.$message.error({message: err.response.data.details.data.message});
      }).finally((res) => {
        this.form_loading = false
      })
    },
    validateEmail(email) {
      var emailRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .div{display: flex;flex-direction: column;color:#2D3748;font-weight: bold;padding-bottom:20px;}
  .form .div input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .form .div select{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;box-sizing: border-box;}
  .headImage{display: flex;width: 76px;margin-top:15px;}
  .headImage .edit{display: none;padding-bottom:0;width: 76px;height: 76px;position: absolute;justify-content: center;align-items: center;background-color: rgba(0, 0, 0, 0.5);border-radius: 4px;}
  .headImage .edit span{background-color: rgba(255, 255, 255, 0.36);margin-left:0;padding:4px 10px;border-radius:4px;font-weight: bold;color:#ffffff;cursor: pointer;}
  .headImage:hover .edit{display: flex;}
  .headImage img{width: 76px;height: 76px;border-radius: 4px;}
  .default_upload {width: 76px;height: 76px;border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .font-size-16 {font-size: 16px;}
  .margin-top-switch {margin-top: 10px;}
  .content_div {height: 500px;overflow: auto;}
  @media (max-width: 768px) {
    .content_div {height: auto;}
  }
</style>
